<div class="c-menu-list" [ngClass]="cssClass">
  <div class="c-menu-list__title" i18n="@@common.how_to_use_it">How to use it</div>
  <div class="c-menu-list__item onboarding-sidebar--toggle">
    <p500-ui-slide-toggle-field [formControl]="onboardingStatus" class="mr-10"></p500-ui-slide-toggle-field>
    <span i18n="@@common.onboarding_tips">Onboarding Tips</span>
  </div>
  <div class="c-menu-list__content">
    <!--li class="c-menu-list__item" (click)="openDocsBoard()"><p500-ui-icon name="other-wiki h-icon"></p500-ui-icon>Docs Section</li>
    <div class="c-menu-list__item">
      <a href="https://platform500.atlassian.net/servicedesk/customer/portals" target="_blank">
        <p500-ui-icon name="buttons-plane h-icon"></p500-ui-icon>Helpdesk Ticket
      </a>
    </div-->
    <div class="c-menu-list__item">
      <a [href]="knowledgeBaseLink" target="_blank" class="d-flex">
        <p500-ui-icon name="other-wiki h-icon"></p500-ui-icon>
        <span i18n="@@common.knowledge_base">Knowledge Base</span>
      </a>
    </div>
    <div class="c-menu-list__item">
      <a
        href="https://www.notion.so/wiki-irev/Partner-Platform-External-API-1a597feb89e380d68b04fb6c37c01d65"
        target="_blank"
        class="d-flex"
      >
        <p500-ui-icon name="menu-code h-icon"></p500-ui-icon>
        <span i18n="@@common.api_documentation">API Documentation</span>
      </a>
    </div>
    <div class="c-menu-list__item">
      <a class="d-flex" routerLink="/app/changelog">
        <p500-ui-icon name="dataflow-02 h-icon"></p500-ui-icon>
        <span i18n="@@common.changelog">Changelog</span>
      </a>
    </div>
    <div class="c-menu-list__item">
      <a href="https://support.irev.com/en/articles/2458882" target="_blank" class="d-flex">
        <p500-ui-icon name="menu-control h-icon"></p500-ui-icon>
        <span i18n="@@common.product_apps">Product Apps</span>
      </a>
    </div>
    <div class="c-menu-list__item">
      <a href="https://irev.com" target="_blank" class="d-flex">
        <p500-ui-icon name="irev h-icon"></p500-ui-icon>
        <span i18n="@@common.irev_website">IREV Website</span>
      </a>
    </div>
  </div>
</div>
